// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"spinner_Spinner__bN_B2","brand":"spinner_brand__UwPRg"};